import React from 'react';
import {
    Switch,
    Route,
    useRouteMatch
} from 'react-router-dom';
import ProgressionBarLarge from './progressionBar/ProgressionBarLarge';
import ProgressionBarLargeTwo from './progressionBar/ProgressionBarLargeTwo';
import YourInformationLarge from './steps/YourInformationLarge';
import SelectServicesLarge from './steps/SelectServicesLarge';
import PrimaryContractLarge from './steps/PrimaryContractLarge';
import SecondaryContractLarge from './steps/SecondaryContractLarge';
import SummarySubmitLarge from './steps/SummarySubmitLarge';
import PromotionCodeLarge from './steps/PromotionCodeLarge';
import { useSelector } from 'react-redux';
import { selectCompanyInfo } from '../../../store/reducers/companyInfoReducer';
import { countryCodes } from '../../../constants';

function FormLarge() {
    const companyInformation = useSelector(selectCompanyInfo);
    let { path } = useRouteMatch();

    return (
        <div className="form_container">
            <Switch>
                <Route exact path={path}>
                    <div className="register_container_outer">
                        <ProgressionBarLargeTwo item={1} progression={path} />
                        <SelectServicesLarge companyInfo={companyInformation} />  
                    </div>
                </Route>
                <Route path={`${path}/info`}>
                    <div className="register_container_outer">  
                        <ProgressionBarLarge item={2} progression={`${path}/info`} />
                        <YourInformationLarge companyInfo={companyInformation} countryCodeArr={countryCodes}/>
                    </div>
                </Route>
                <Route path={`${path}/primary`}>
                    <div className="register_container_outer">
                        <ProgressionBarLarge item={3} progression={`${path}/primary`} />                        
                        <PrimaryContractLarge companyInfo={companyInformation} countryCodeArr={countryCodes} />
                    </div>
                </Route>
                <Route path={`${path}/secondary`}>
                    <div className="register_container_outer">
                        <ProgressionBarLarge item={3} progression={`${path}/secondary`} />
                        <SecondaryContractLarge companyInfo={companyInformation} countryCodeArr={countryCodes} />
                    </div>
                </Route>

                <Route path={`${path}/nomination`}>
                    <div className="register_container_outer">  
                        <ProgressionBarLarge item={4} progression={`${path}/nomination`} />
                        <PromotionCodeLarge companyInfo={companyInformation}/>
                    </div>
                </Route>

                <Route path={`${path}/summary`}>
                    <div className="register_container_outer">
                        <ProgressionBarLarge item={5} progression={`${path}/summary`} />
                        <SummarySubmitLarge companyInfo={companyInformation} />
                    </div>
                </Route>
            </Switch> 
        </div>
    );
}

export default FormLarge;
